import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import NegotiationDashboard from '../components/NegotiationDashboard';

export default function NegotiationPage() {
  const { parentType, parentId } = useParams();
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 sm:px-6 py-6">
        <Link to="/buyer-dashboard" className="inline-flex items-center text-sm text-muted-foreground hover:text-navy mb-4" data-testid="back-to-buyer-dashboard">
          <ArrowLeft className="h-4 w-4 mr-1.5" /> Back to Buyer Dashboard
        </Link>
        <div className="mb-4">
          <h1 className="text-2xl font-bold text-navy">Negotiation</h1>
          <p className="text-xs text-muted-foreground">Live negotiation dashboard for {parentType === 'tender' ? 'Tender' : 'Quick Quotation'} <span className="font-mono">{parentId}</span></p>
        </div>
        <NegotiationDashboard parentType={parentType} parentId={parentId} />
      </div>
    </div>
  );
}
